import gql from "graphql-tag";

const resultField = `
id
name
description
year
startDate
endDate
duration
type
createdAt
updatedAt
`;
const createHoliday = gql`
  mutation(
    $name: String!
    $description: String
    $type: String
    $year: Int!
    $startDate: DateTime!
    $endDate: DateTime!
    $duration: Float!
  ) {
    createHoliday(
      data: {
        name: $name
        description: $description
        type: $type
        year: $year
        startDate: $startDate
        endDate: $endDate
        duration: $duration
      }
    ) {
      ${resultField}
    }
  }
`;

const updateHoliday = gql`
  mutation(
    $id: ID!
    $name: String
    $type: String
    $description: String
    $year: Int
    $startDate: DateTime
    $endDate: DateTime
    $duration: Float
  ) {
    updateHoliday(
      id: $id
      data: {
        name: $name
        type: $type
        description: $description
        year: $year
        startDate: $startDate
        endDate: $endDate
        duration: $duration
      }
    ) {
      ${resultField}
    }
  }
`;

const deleteHoliday = gql`
  mutation($id: ID!) {
    deleteHoliday(id: $id) {
      id
    }
  }
`;

const getListHoliday = gql`
  query(
    $limit: Int
    $page: Int
    $query: String
    $year: Int
    $startDate: DateTime
    $endDate: DateTime
  ) {
    getListHoliday(
      query: $query
      paging: { limit: $limit, page: $page }
      filter: { year: $year, startDate: $startDate, endDate: $endDate }
    ) {
      ${resultField}
    }
  }
`;

const getDetailHoliday = gql`
  query($id: ID!) {
    getDetailHoliday(id: $id) {
      ${resultField}
      author {
        id
        username
        fullname
      }
    }
  }
`;

export default {
  createHoliday,
  updateHoliday,
  deleteHoliday,
  getListHoliday,
  getDetailHoliday,
};
